export const all_routes = {
  dashboard: "/",
  signin: "/signin",
  company: "/company",
  dynamicpage: "/RepOpt/:id",
  dynamiclist: "/RepList/:id",
  voucherList: "/V-10001",
  order: "/order",
  receipt: "/receipt",
  // =============user===============
  userlist: "/userlist",
  userpage: "/createuser",
  catalogue: "/catalogue/:id",
  custsupplogin: "/custsupplogin",
};
